<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onOkClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <p>
                        Customer: {{company.registeredCompanyName}}
                    </p>
                    <p v-if="company.tradingAs">
                        Trading As: {{company.tradingAs}}
                    </p>
                    <p v-if="company.branchName">
                        Branch: {{company.branchName}}
                    </p>
                    <p v-if="company.branchNumber">
                        Branch Number: {{company.branchNumber}}
                    </p>
                </div>
                <hr>
                <shipping-address-for-order :companyId="company.companyId" @shippingAddressSelected="onShippingAddressSelected"></shipping-address-for-order>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" data-dismiss="modal" @click="onOkClick" :disabled="loading">Cancel</button>
            </div>
        </div>
    </div>
</div>